export const REDIRECT_GUARD_KEY = 'cognito-redirect-attempted';

// Long enough to cover a Cognito sign-in round trip; short enough that a stale marker from an
// abandoned sign-in doesn't block the next genuine redirect in the same tab.
const REDIRECT_GUARD_WINDOW_MS = 5 * 60 * 1000;

export function oauthStartUrl(apiBase: string, returnTo: string): string {
  return `${apiBase}/oauth2/start?rd=${encodeURIComponent(returnTo)}`;
}

export function navigateTo(url: string): void {
  window.location.href = url;
}

// False when the guard can't be stored; an automatic redirect without it could loop forever.
export function markRedirectAttempt(now = Date.now()): boolean {
  try {
    sessionStorage.setItem(REDIRECT_GUARD_KEY, String(now));
    return true;
  } catch {
    return false;
  }
}

export function clearRedirectAttempt(): void {
  try {
    sessionStorage.removeItem(REDIRECT_GUARD_KEY);
  } catch {
    // Best-effort, as above.
  }
}

export function recentlyRedirected(now = Date.now()): boolean {
  let raw: string | null;
  try {
    raw = sessionStorage.getItem(REDIRECT_GUARD_KEY);
  } catch {
    return false;
  }
  const attemptedAt = Number(raw);
  if (!raw || !Number.isFinite(attemptedAt)) return false;
  return now - attemptedAt < REDIRECT_GUARD_WINDOW_MS;
}

// 401 is the edge's CORS-readable "no session" answer; no status means the request never got a
// readable response (network or CORS), which sign-in may also fix. Anything else is not auth.
export function shouldRedirectToSignIn(status: number | undefined, apiBase: string, now = Date.now()): boolean {
  if (!apiBase) return false;
  if (status !== 401 && status !== undefined) return false;
  return !recentlyRedirected(now);
}
